// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { PublicationVersionSummary } from "./PublicationVersionSummary";
import {
  PublicationVersionSummaryFromJSON,
  PublicationVersionSummaryFromJSONTyped,
  PublicationVersionSummaryToJSON,
  PublicationVersionSummaryToJSONTyped,
} from "./PublicationVersionSummary";

/**
 *
 * @export
 * @interface PagePublicationVersionSummary
 */
export interface PagePublicationVersionSummary {
  /**
   *
   */
  total: number;
  /**
   *
   */
  items: Array<PublicationVersionSummary>;
  /**
   *
   */
  limit?: number | null;
  /**
   *
   */
  offset?: number | null;
}

/**
 * Check if a given object implements the PagePublicationVersionSummary interface.
 */
export function instanceOfPagePublicationVersionSummary(
  value: object
): value is PagePublicationVersionSummary {
  if (!("total" in value) || value["total"] === undefined) return false;
  if (!("items" in value) || value["items"] === undefined) return false;
  return true;
}

export function PagePublicationVersionSummaryFromJSON(json: any): PagePublicationVersionSummary {
  return PagePublicationVersionSummaryFromJSONTyped(json, false);
}

export function PagePublicationVersionSummaryFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PagePublicationVersionSummary {
  if (json == null) {
    return json;
  }
  return {
    total: json["total"],
    items: (json["items"] as Array<any>).map(PublicationVersionSummaryFromJSON),
    limit: json["limit"] === undefined ? undefined : json["limit"] === null ? null : json["limit"],
    offset:
      json["offset"] === undefined ? undefined : json["offset"] === null ? null : json["offset"],
  };
}

export function PagePublicationVersionSummaryToJSON(json: any): PagePublicationVersionSummary {
  return PagePublicationVersionSummaryToJSONTyped(json, false);
}

export function PagePublicationVersionSummaryToJSONTyped(
  value?: PagePublicationVersionSummary | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    total: value["total"],
    items: (value["items"] as Array<any>).map(PublicationVersionSummaryToJSON),
    limit: value["limit"],
    offset: value["offset"],
  };
}
